function EmptyStateTable({ colSpan }) {
  return (
    <>
      <tr>
        <td colSpan={colSpan ?? 1} className="text-center align-middle">
          <div className="d-flex justify-content-center align-items-center gap-2">Data not Found</div>
        </td>
      </tr>
    </>
  );
}
export default EmptyStateTable;
